<div>
  <fw-wrapped-input [description]="description()" [title]="title()">
    @if (storagesResource.isLoading()) {
      <fw-select
        test-id="operation-storage-select-loading"
        width="100%"
        [disabled]="true"
        [placeholder]="placeholder()"
      />
    } @else {
      <fw-select
        test-id="operation-storage-select"
        width="100%"
        [disabled]="isDisabled()"
        [maxOptionsHeight]="maxOptionsHeight()"
        [optionsWidth]="optionsWidth()"
        [placeholder]="placeholder()"
        [value]="currentValue()"
        (change)="onStorageSelect($event)"
        (filterChanged)="filterChange($event)"
      >
        @for (storage of extraOptions; track storage._id) {
          <fw-menu-item
            [description]="storage.url"
            [hidden]="!visibleExtraOptions().has(storage)"
            [title]="storage.label"
            [value]="storage._id"
          />
        }

        @if (visibleExtraOptions().size) {
          <fw-menu-separator />
        }

        @for (storage of storagesResource.value() ?? []; track storage._id) {
          <fw-menu-item
            [description]="storage.url"
            [hidden]="!visibleOptions().has(storage)"
            [title]="storage.label"
            [value]="storage._id"
          />
        }

        @if (!visibleExtraOptions().size && !visibleOptions().size) {
          <fw-menu-item title="No Results" [disabled]="true" />
        }
      </fw-select>
    }
  </fw-wrapped-input>
</div>
